import * as winston from 'winston';

import BrowserConsoleTransport from './winston-browser-console';
import RollbarTransport from './winston-rollbar';

export type LogLevel = 'error' | 'warn' | 'info' | 'http' | 'verbose' | 'debug' | 'silly';

const DEBUG = process.env.DEBUG === 'true';
const TARGET = process.env.TARGET || 'client';

const defaultFormats = [
	winston.format.timestamp(),
	winston.format.json()
];

const clientTransports = [
	new BrowserConsoleTransport({
		level: DEBUG ? 'debug' : 'info',
	}),
	new RollbarTransport({ level: DEBUG ? 'debug' : 'info' })
];

const serverTransports = [
	new winston.transports.Console({
		level: DEBUG ? 'debug' : 'info',
	})
];

const loggerFactory = () => winston.createLogger({
	transports: TARGET === 'client' ? clientTransports : serverTransports,
	format: winston.format.combine(...defaultFormats),
	exitOnError: false
});

export const logging = loggerFactory();

export default loggerFactory;
